<template>
  <transition name="fade" mode="out-in">
    <section v-if="badgePage" id="price-badge" :class=" { 'fixedBadge' : scrolled } ">
      <h1>{{title}}</h1>
      <span id="total"><span id="netto">netto </span><span v-if="monthlyPaymentSelected" id="numberOfMonths">24x </span>{{animatedNumber}}</span>
    </section>
  </transition>
</template>

<script>
import TweenLite from 'gsap/TweenMax'
// import Checkbox from '@/components/Checkbox.vue'

export default {
  name: 'PriceBadge',
  props: {
    total: Number,
    monthlyPaymentSelected: Boolean
  },
  data: function () {
    return {
      tweenedNumber: this.total,
      window: {
        pageYOffset: 0
      }
    }
  },
  methods: {
    handleScroll: function () {
      this.window.pageYOffset = window.pageYOffset
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title
    },
    scrolled: function () {
      if (this.window.pageYOffset > 80) {
        return true
      } else {
        return false
      }
    },
    animatedNumber: function () {
      return this.tweenedNumber.toFixed(0)
    },
    currentRouteName: function () {
      return this.$route.name
    },
    badgePage: function () {
      switch (this.currentRouteName) {
        case 'Account':
        case 'Projekte':
        case 'Timeline':
        case 'Start':
          return false
        default:
          return true
      }
    }
  },
  watch: {
    total: function (newValue) {
      TweenLite.to(this.$data, 0.2, { tweenedNumber: newValue })
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="scss">

@import "../assets/css/variables.scss";

@media (max-width: 766px) {
  #price-badge {
    &.fixedBadge {
      position: fixed;
      top: 0;
    }
  }
}
#price-badge {
  position: absolute;
  width: 100%;
  background: $primaryColor;
  height: 50px;
  padding: 0 15px 0 15px;
  display: flex;
  align-items: center;
  justify-content: right;
  z-index: 5;
  border-bottom: 1px solid #607BFF;
}
h1 {
  font-family: $primaryFont;
  font-weight: $primaryFontBold;
  color: #fff;
  margin: 2px 0 0 0;
  font-size: 16px;
}
.closed-large-overview {
  h1 {
    margin: 2px 0 0 0;
  }
}
#total {
  font-family: $primaryFont;
  font-weight: $primaryFontBold;
  color: #fff;
  font-size: 22px;
  transform: translate3d(0,0,0);
  margin-left: auto;
}
#numberOfMonths,
#netto {
  display: none; /* TO REMOVE */
  opacity: 0.8;
  font-family: $secondaryFont;
  font-weight: $secondaryFontNormal;
  color: #fff;
  font-size: 18px;
}
#total:after {
  padding-left: 5px;
  content: '€';
}
/*
@media(min-width:400px) {
  #app-header {
    height: 90px;
  }
}
*/
@media(min-width:420px) {
  h1 {
    font-size: 18px;
  }
}
@media(min-width:767px) {
  h1 {
    margin: 2px 0 0 92px;
    font-size: 20px;
  }
  .closed-large-overview {
    h1 {
      margin: 2px 0 0 92px;
    }
  }
  #price-badge {
    position: fixed;
    right: 0;
    padding: 0 40px 0 40px;
    height: 60px;
  }
  #total {
    font-size: 24px;
  }
}
@media (min-width:1180px) {
  h1 {
    margin: 2px 0 0 282px;
  }
}
.fade-enter-active,
.fade-leave-active {
  position: relative;
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
